<div class="row">
    <div class="col-lg-12">
        <div class="card selectColumns isMinimizable minimize">
            <div class="card-header">
                <div class="card-title">
                    <i class="fa fa-angle-up"></i>
                    <h2>Personnalisation du PDF</h2>
                </div>
            </div>
            <div class="card-body">

                <mat-button-toggle-group class="container-fluid" [multiple]="true"
                                         #group="matButtonToggleGroup"
                                         [value]="user.user_dashboard.pdf_page"
                                         (change)="onPageChange(group.value)">
                    <div class="col-md-12 page-list">
                        <h3>Sélection des pages</h3>

                        <mat-button-toggle value="annonce">
                            Annonce
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="secteur">
                            Analyse du secteur
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="secteur_bis" class="last">
                            Analyse du secteur - page 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="analyse">
                            Analyse du projet
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="video">
                            Vidéo du projet
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_1" class="last">
                            Photo du projet
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_2">
                            Photo du projet - Page 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_3">
                            Photo du projet - Page 3
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_4" class="last">
                            Photo du projet - Page 4
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_5">
                            Photo du projet - Page 5
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo_6">
                            Photo du projet - Page 6
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="work" class="last">
                            Travaux à prévoir
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance">
                            Analyse financière
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance_25">
                            Analyse financière sur 25 ans
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance_2" class="last">
                            Analyse financière page 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance_3">
                            Analyse financière page 3
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance_3_25">
                            Analyse financière sur 25 ans page 3
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </div>
                </mat-button-toggle-group>

                <mat-button-toggle-group class="container-fluid" [ngModel]="user.user_dashboard.pdf_quality"
                                         (change)="user.user_dashboard.pdf_quality = $event.value;updateDashboard()">
                    <div class="col-md-12">
                        <h3>Qualité du rapport</h3>
                        <mat-button-toggle value="normal">
                            Standard / Rapide
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                        <mat-button-toggle value="hd" class="last">
                            Haute définition
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </div>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
</div>

<div class="book">
    <div id="book">
        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>

        <div id="annonce" class="page">
            <div class="subpage">
                <div class="logo_wrap">
                    <img class="logo" src="{{ pdfConfig.logo_url }}"/>
                </div>
                <div class="title">
                    {{ favorite.title }}
                </div>
                <div class="kpi-3">
                    <div class="kpi kpi-color-1">
                        <img class="icon" src="assets/coins_white.png"/>
                        <label>Investissement total</label>
                        <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
                    </div>
                    <div class="kpi kpi-color-3">
                        <img class="icon" src="assets/009-get-money_white.png"/>
                        <label>Rendement brut</label>
                        <p class="value">{{ efficiency_brut | number: '1.1-1' }} %</p>
                    </div>
                    <div class="kpi kpi-color-2">
                        <img class="icon" src="assets/adress.svg" *ngIf="favorite.ad_city.name.length <= 15"/>
                        <label>Localisation</label>
                        <p class="value city_value {{ favorite.ad_city.name.length <= 20 ? '' : 'small_city_value' }}">
                            {{ favorite.ad_city.name }}
                        </p>
                    </div>
                </div>
                <div class="desc">
                    <b>Descriptif du projet</b>
                    <p class="wrap_textarea">
                        <textarea matInput [(ngModel)]="favorite.description"
                                  (ngModelChange)="edit($event, 'description')"></textarea>
                    </p>
                </div>
                <div class="pictures">
                    <div class="wrap"
                         [ngClass]="{'small': favorite.pictures.length <= 3, 'big': favorite.pictures.length > 3}">
                        <img id="my-image" class="picture"
                             *ngFor="let picture of favorite.pictures.slice(0,5); index as i;"
                             [hidden]="picture == '/assets/no-photo.png'"
                             src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
                    </div>
                </div>
                <div class="contact row" *ngIf="pdfConfig.display_contact">
                    <ng-container>
                        <div class="col-md-10 offset-1" [innerHTML]="pdfConfig.contact">
                        </div>
                    </ng-container>
                </div>
                <p class="bottom_link" *ngIf="!pdfConfig.display_contact">
                    <span>Analyses et dossier effectués avec <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="secteur" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du secteur
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>

                    <div class="card block block_info card-border">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Localisation du bien</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <div class="col-7 indicateur">
                                    <div class="row">
                                        <div class="col-3 text-center">
                                            <img class="img-fluid" src="assets/pdf/oikos/pin.png"/>
                                        </div>
                                        <div class="col-9 mb-5 adress">
                                            {{ favorite.adress }} <br/>
                                            {{ favorite.ad_city.zip_code }} {{ favorite.ad_city.name }}
                                        </div>
                                        <div class="card-text row">
                                            <div class="col-3 text-center">
                                                <img class="img-fluid" src="assets/pdf/oikos/plan.png"/>
                                            </div>
                                            <div class="col-9 region">
                                                {{ favorite.ad_city.departement }}<br/>
                                                {{ favorite.ad_city.region }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 text-center" *ngIf="favorite.id != ''">
                                    <img class="img-fluid mb-4 rounded-5" src="{{apiUrl}}img/{{ favorite.id }}/map"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="kpi-2 mb-0">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/032-human-resources_white.png"/>
                            <label>Nombre d'habitants</label>
                            <p class="value">{{ favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0'}}</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/measure_white.png"/>
                            <label>Prix au m² moyen</label>
                            <p class="value">{{ advice_price | number: '1.0-0' }} €/m²</p>
                        </div>
                    </div>

                    <div class="text-center">
                        <img class="img-fluid mt-5 mb-5 rounded-5" src="{{apiUrl}}img/{{ favorite.id }}/city/oikos"/>
                    </div>
                    <div class="desc">
                        <b>Notre avis sur la localisation</b>
                        <p class="wrap_textarea">
                            <textarea matInput [(ngModel)]="favorite.comment_city"
                                      (ngModelChange)="edit($event, 'comment_city')"></textarea>
                        </p>
                    </div>
                </div>
                <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="secteur_bis" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du secteur
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="card block block_info">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Informations sur la ville</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Niveau de vie moyen par habitant
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }}
                                        <span
                                            class="unit text-green">€</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de logements vacants
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux d'étudiants
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de chômage
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>

                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de taxe foncière
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.logement.TF * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Ancienneté des locataires
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }}
                                        <span class="unit text-green">ans</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Part des ménages ayant au moins 1 voiture
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.logement['T_Men_1+voit'] * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Part des ménages ayant une place de parking
                                    </label>
                                    <b class="value text-green">{{ favorite.ad_city.logement.T_Men_park * 100 | number: '1.1-1' }}
                                        <span class="unit text-green">%</span></b>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card block block_evol">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Nombre d'habitants</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row" *ngIf="habitantEvolData.series.length > 0">
                                <div echarts [options]="habitantEvolOptions" [merge]="habitantEvolData"
                                     class="habitantEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                     (chartInit)="onHabitantEvolInit($event)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card block block_evol">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution du nombre d'entreprises</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row" *ngIf="entrepriseEvolData.series.length > 0">
                                <div echarts [options]="entrepriseEvolOptions" [merge]="entrepriseEvolData"
                                     class="entrepriseEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                     (chartInit)="onEntrepriseEvolInit($event)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_rent">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-blue">Loyer moyen</h3>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row">
                                    <div echarts [options]="rentOptions" [merge]="rentData"
                                         class="rentChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                         (chartInit)="onRentChartInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="card block block_price">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution des prix de
                                        l'immobilier</h3>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row" *ngIf="priceEvolData.series.length > 0">
                                    <div echarts [options]="priceEvolOptions" [merge]="priceEvolData"
                                         class="priceEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                         (chartInit)="onPriceChartInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
                <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="analyse" class="page">
            <div class="subpage">

                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>

                    <div class="kpi-3">
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/030-sale-white.svg"/>
                            <label>Prix Initial</label>
                            <p class="value" *ngIf="favorite.ad.ai_id == 0">{{ favorite.init_price|number:'1.0-1'}}
                                €</p>
                            <p class="value" *ngIf="favorite.ad.ai_id != 0">{{ favorite.ad.price|number:'1.0-1'}} €</p>
                        </div>
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/007-buy-1-white.svg"/>
                            <label>Prix d'achat</label>
                            <p class="value">{{ favorite.price|number:'1.0-1'}} €</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/031-tax-white.svg"/>
                            <label>Frais de notaire</label>
                            <p class="value">{{ favorite.notary_price|number:'1.0-1'}} €</p>
                        </div>
                    </div>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-2 kpi-label-2">
                            <label>Honoraires de <br/>chasse Oikos</label>
                            <p class="value">{{ favorite.other_fees|number:'1.0-1'}} €</p>
                        </div>
<!--                        <div class="kpi kpi-color-3 kpi-label-2">-->
<!--                            <label>Assistance de maitrise d’ouvrage</label>-->
<!--                            <p class="value">{{ favorite.other_fees_work|number:'1.0-1'}}-->
<!--                                €</p>-->
<!--                        </div>-->
                        <div class="kpi kpi-color-3 kpi-label-2">
                            <label>Montant<br/>des travaux</label>
                            <p class="value">{{ favorite.works_total+ favorite.other_fees_work |number:'1.0-1'}} €</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <label>Ameublement</label>
                            <p class="value">{{ favorite.furniture_price|number:'1.0-1'}} €</p>
                        </div>
                    </div>

                    <div class="kpi-1">
                        <div class="kpi kpi-color-10">
                            <img class="icon" src="assets/021-investment-4-white.svg"/>
                            <label>Investissement Total</label>
                            <p class="value">{{ favorite.total_price|number:'1.0-1'}} €</p>
                        </div>
                    </div>

                    <div class="card block">
                        <!--                    <div class="card-header">-->
                        <!--                        <div class="card-title">-->
                        <!--                            <h3 class="{{ pdfConfig.h3_class}} text-blue">Charges annuelles</h3>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <div class="card-body col-md-12 p-0">
                            <div class="card-text">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <!--                                        <th>Type</th>-->
                                        <th>Lot</th>
                                        <th>Surface</th>
                                        <th>Loyer HC</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let lot of favorite.lots; index as i;">
                                        <!--                                        <td>{{ cityService.fields[lot.advice_rent_choice].lib }}</td>-->
                                        <td>{{ lot.title }}</td>
                                        <td class="number">{{ lot.square }} m²</td>
                                        <td class="number">{{ lot.amount_rent|number:'1.0-1' }} €</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td class="number" colspan="2">Total</td>
                                        <td class="number">{{ favorite.amount_rent|number:'1.0-1' }} €/mois</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="number">{{ favorite.amount_rent * 12|number:'1.0-1' }}
                                            €/an
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="desc">
                        <b>Informations complémentaires</b>
                        <p class="wrap_textarea">
                            <textarea style="max-height: 350px;" matInput [(ngModel)]="favorite.comment"
                                      (ngModelChange)="edit($event, 'comment')"></textarea>
                        </p>
                    </div>
                </div>
                <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="video" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Vidéo de visite
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <p class="text-center click" *ngIf="favorite.id != ''">
                        <img id="image-video" class="picture img-fluid"
                             src="{{apiUrl}}img/{{ favorite.id }}/0?rand={{rand}}"><br/>
                        <img style="width: 200px;margin-top: -100px;" class="icon"
                             src="assets/pdf/oikos/click.png"/><br/>
                        Cliquez sur la photo pour<br/>
                        télécharger la vidéo de visite via<br/>
                        We Transfer<br/>
                    </p>
                </div>
                <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_1"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_1" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:0:nbPictures_1; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_2"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_2" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:nbPictures_1:nbPictures_1+nbPictures_2; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i+nbPictures_1}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_3"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_3" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:nbPictures_1+nbPictures_2:nbPictures_1+nbPictures_2+nbPictures_3; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i+nbPictures_1+nbPictures_2}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_4"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_4" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:nbPictures_1+nbPictures_2+nbPictures_3:nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i+nbPictures_1+nbPictures_2+nbPictures_3}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_5"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_5" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4:nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4+nbPictures_5; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i+nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Nombre de photos à afficher :</label>
            <input type="number" class="input_title ms-4" [(ngModel)]="nbPictures_6"
                   (ngModelChange)="edit($event, 'pictures')">
        </div>

        <div id="photo_6" class="page">
            <div class="subpage text-center">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}} text-start">
                        Photos du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <img class="picture_all"
                         *ngFor="let picture of favorite.pictures| slice:nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4+nbPictures_5:nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4+nbPictures_5+nbPictures_6; index as i;"
                         [hidden]="picture == '/assets/no-photo.png'"
                         src="{{apiUrl}}img/{{ favorite.id }}/{{i+nbPictures_1+nbPictures_2+nbPictures_3+nbPictures_4+nbPictures_5}}?rand={{rand}}">
                </div>
            </div>
            <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
            </p>
        </div>

        <div id="work" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Travaux à prévoir
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>

                    <div class="kpi-2">
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/home-white.svg"/>
                            <label>Montant des travaux</label>
                            <p class="value">{{ favorite.works_total+ favorite.other_fees_work |number:'1.0-1'}} €</p>
                        </div>
<!--                        <div class="kpi kpi-color-3 kpi-label-2">-->
<!--                            <img class="icon" src="assets/014-engineer-2-white.svg"/>-->
<!--                            <label>Assistance de maitrise d’ouvrage (AMO)</label>-->
<!--                            <p class="value">{{ favorite.other_fees_work|number:'1.0-1'}}-->
<!--                                €</p>-->
<!--                        </div>-->
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/014-engineer-2-white.svg"/>
                            <label>Ameublement</label>
                            <p class="value">{{ favorite.furniture_price|number:'1.0-1'}} €</p>
                        </div>
                    </div>

                    <div class="card block">
                        <div class="card-body col-md-12 p-0">
                            <div class="card-text">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                    <tr>
                                        <th>Lot</th>
                                        <th>Menuiseries</th>
                                        <th>Chauffage</th>
                                        <th>DPE</th>
                                        <th>Montant</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let lot of favorite.lots; index as i;">
                                        <td>{{ lot.title }}</td>
                                        <td>{{ lot.window }}</td>
                                        <td>{{ lot.heating }}</td>
                                        <td>{{ lot.dpe }}</td>
                                        <td class="number">{{ lot.works_total | number }} €</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="desc">
                        <b>Informations complémentaires</b>
                        <p class="wrap_textarea" style="height: auto !important; max-height: 570px !important;">
                            <textarea style="height: 450px; max-height: 600px;" matInput
                                      [(ngModel)]="favorite.comment_work"
                                      (ngModelChange)="edit($event, 'comment_work')"></textarea>
                        </p>
                    </div>
                </div>
                <p class="bottom_link">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>

            </div>
        </div>

        <div id="finance" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière sur {{ favorite.duration }} ans
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="{{ pdfConfig.visuel_2 != '' ? 'kpi-4' : 'kpi-3'}}">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer mensuel HC</label>
                            <p class="value">{{ favorite.amount_rent | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-2 kpi-label-2">
                            <img class="icon" src="assets/030-cash.png"/>
                            <label>Charges mensuelles<br/>(avec crédit)</label>
                            <p class="value">{{ favorite.charge + favorite.monthly | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img *ngIf="pdfConfig.visuel_2 == ''" class="icon" src="assets/key-white.png"/>
                            <label>Taxe foncière</label>
                            <p class="value">{{ favorite.amount_property_tax | number: '1.0-0' }} €</p>
                        </div>
                    </div>

                    <div class="kpi-2">
                        <div class="kpi kpi-color-4">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ efficiency_brut | number: '1.1-1' }} %</p>
                        </div>
                        <div class="kpi kpi-color-4">
                            <img class="icon" src="assets/investment.png"/>
                            <label>Rendement net de TF</label>
                            <p class="value">{{ ((favorite.amount_rent * 12) - favorite.amount_property_tax) * 100 / favorite.total_price | number: '1.1-1' }}
                                %</p>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_capitalisation">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution du capital net</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row" *ngIf="capitalData.series.length > 0">
                                    <div echarts [options]="options_Evol_Capital" [merge]="capitalData"
                                         class="capitalChart {{ pdfConfig.visuel_3 == '' ? 'small' : '' }}"
                                         (chartInit)="onChartECInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <div class="kpi-1">
                        <div class="kpi kpi-color-green">
                            <img class="icon" src="assets/pdf/oikos/plus-oikos-2.png"/>
                            <label>Patrimoine acquis par an</label>
                            <p class="value">{{ amort_moy  | number: '1.0-0' }} €</p>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <p class="text-center text-grey fs-6">
                        Note : Le patrimoine acquis correspond à la somme du cash-flow<br/>
                        généré par le projet, et du remboursement de capital sur votre prêt<br/>
                        immobilier.<br/>
                        Il ne prend pas en compte la plus-value à la revente.<br/>
                        <br/>
                        <br/>
                        <img class="icon" src="assets/pdf/oikos/icone-house-oikos.png"/>
                    </p>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                    Document non contractuel sous réserve d'acceptation et normes des banques en vigueur.
                </span>
                </p>
            </div>
        </div>

        <div id="finance_25" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière sur 25 ans
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="{{ pdfConfig.visuel_2 != '' ? 'kpi-4' : 'kpi-3'}}">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer mensuel HC</label>
                            <p class="value">{{ favorite.amount_rent | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-2 kpi-label-2">
                            <img class="icon" src="assets/030-cash.png"/>
                            <label>Charges mensuelles<br/>(avec crédit)</label>
                            <p class="value">{{ favorite.charge + monthly25 | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img *ngIf="pdfConfig.visuel_2 == ''" class="icon" src="assets/key-white.png"/>
                            <label>Taxe foncière</label>
                            <p class="value">{{ favorite.amount_property_tax | number: '1.0-0' }} €</p>
                        </div>
                    </div>

                    <div class="kpi-2">
                        <div class="kpi kpi-color-4">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ efficiency_brut | number: '1.1-1' }} %</p>
                        </div>
                        <div class="kpi kpi-color-4">
                            <img class="icon" src="assets/investment.png"/>
                            <label>Rendement net de TF</label>
                            <p class="value">{{ ((favorite.amount_rent * 12) - favorite.amount_property_tax) * 100 / favorite.total_price | number: '1.1-1' }}
                                %</p>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_capitalisation">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution du capital net</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row" *ngIf="capitalData25.series.length > 0">
                                    <div echarts [options]="options_Evol_Capital25" [merge]="capitalData25"
                                         class="capitalChart {{ pdfConfig.visuel_3 == '' ? 'small' : '' }}"
                                         (chartInit)="onChartECInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <div class="kpi-1">
                        <div class="kpi kpi-color-green">
                            <img class="icon" src="assets/pdf/oikos/plus-oikos-2.png"/>
                            <label>Patrimoine acquis par an</label>
                            <p class="value">{{ amort_moy25  | number: '1.0-0' }} €</p>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <p class="text-center text-grey fs-6">
                        Note : Le patrimoine acquis correspond à la somme du cash-flow<br/>
                        généré par le projet, et du remboursement de capital sur votre prêt<br/>
                        immobilier.<br/>
                        Il ne prend pas en compte la plus-value à la revente.<br/>
                        <br/>
                        <br/>
                        <img class="icon" src="assets/pdf/oikos/icone-house-oikos.png"/>
                    </p>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                    Document non contractuel sous réserve d'acceptation et normes des banques en vigueur.
                </span>
                </p>
            </div>
        </div>

        <div id="finance_2" class="page">
            <div class="subpage">

                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="block_2graph">
                        <div class="card block block_charges">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-blue">Répartition des charges
                                        mensuelles</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <div echarts [options]="chargeOptions" [merge]="chargeData" class="chargeChart"
                                         (chartInit)="onChargeChartInit($event)"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="row">
                            <div class="col-6">
                                <div class="card block block_recap">
                                    <div class="card-header">
                                        <div class="card-title">
                                            <h3 class="{{ pdfConfig.h3_class}} text-blue">Charges annuelles</h3>
                                        </div>
                                    </div>
                                    <div class="card-body col-md-12">
                                        <div class="card-text row">
                                            <table>
                                                <tr>
                                                    <th>Taxe foncière</th>
                                                    <td>
                                                        {{favorite.amount_property_tax}} €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Assurance PNO</th>
                                                    <td>
                                                        {{favorite.building_insurance}} €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Gestion agence</th>
                                                    <td>
                                                        {{ favorite.amount_rent * favorite.agence / 100 * 12 |number:'1.0-1'}}
                                                        €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Charges de copropriété</th>
                                                    <td>
                                                        {{favorite.amount_copro}} €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Autres frais</th>
                                                    <td>
                                                        {{favorite.other_bill }} €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Comptabilité</th>
                                                    <td>
                                                        {{favorite.accouting_fees + favorite.cfe_contribution}}
                                                        €/an
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Total</th>
                                                    <td>
                                                        <b>{{ favorite.charge * 12 | number: '1.0-0' }} €/an</b>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="card block block_recap">
                                    <div class="card-header">
                                        <div class="card-title">
                                            <h3 class="{{ pdfConfig.h3_class}} text-blue">Achat</h3>
                                        </div>
                                    </div>
                                    <div class="card-body col-md-12">
                                        <div class="card-text row">
                                            <table>
                                                <tr>
                                                    <th>Prix d'achat FAI</th>
                                                    <td>{{ favorite.price|number:'1.0-1'}} €</td>
                                                </tr>

                                                <tr>
                                                    <th>Surface</th>
                                                    <td>{{ favorite.square|number:'1.0-1'}} m²</td>
                                                </tr>
                                                <tr>
                                                    <th>Frais de notaire</th>
                                                    <td>{{ favorite.notary_price|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Honoraires de chasse</th>
                                                    <td>{{ favorite.other_fees|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Meubles</th>
                                                    <td>{{ favorite.furniture_price|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Travaux</th>
                                                    <td>{{ favorite.works_total + favorite.other_fees_work |number:'1.0-1'}} €</td>
                                                </tr>
<!--                                                <tr>-->
<!--                                                    <th>Assistance de maitrise d’ouvrage (AMO)</th>-->
<!--                                                    <td>{{ favorite.other_fees_work|number:'1.0-1'}}-->
<!--                                                        €-->
<!--                                                    </td>-->
<!--                                                </tr>-->
                                                <tr>
                                                    <th>Total achat</th>
                                                    <td><b>{{ favorite.total_price|number:'1.0-1'}} €</b></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="card block block_recap last">
                                    <div class="card-header">
                                        <div class="card-title">
                                            <h3 class="{{ pdfConfig.h3_class}} text-blue">Indicateurs clés </h3>
                                        </div>
                                    </div>
                                    <div class="card-body col-md-12">
                                        <div class="card-text row">
                                            <table>
                                                <tr>
                                                    <th> Prix au m² à l'achat</th>
                                                    <td>{{ favorite.price / favorite.square |number:'1.0-0'}} €/m²</td>
                                                </tr>
                                                <tr>
                                                    <th>Prix au m² final</th>
                                                    <td>{{ favorite.total_price / favorite.square|number:'1.0-0'}}
                                                        €/m²
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Rendement brut</th>
                                                    <td>{{ efficiency_brut|number:'1.1-1'}} %</td>
                                                </tr>
                                                <tr>
                                                    <th>Rendement net de TF</th>
                                                    <td>{{ ((favorite.amount_rent * 12) - favorite.amount_property_tax) * 100 / favorite.total_price | number: '1.1-1' }}
                                                        %
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Rendement net</th>
                                                    <td>                    {{ favorite.efficiency_net|number:'1.1-1'}}
                                                        %
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Cash-flow annuel</th>
                                                    <td>
                                                        {{ favorite.cash_flow * 12|number:'1.0-0'}} €
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Cash-flow mensuel</th>
                                                    <td>
                                                        {{ favorite.cash_flow |number:'1.0-0'}} €
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Taux de couverture</th>
                                                    <td>{{ favorite.coverage_rate |number:'1.0-1'}} %</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>


                                <div class="card block block_recap last">
                                    <div class="card-header">
                                        <div class="card-title">
                                            <h3 class="{{ pdfConfig.h3_class}} text-blue">Crédit </h3>
                                        </div>
                                    </div>
                                    <div class="card-body col-md-12">
                                        <div class="card-text row">
                                            <table>
                                                <tr>
                                                    <th>Apport</th>
                                                    <td>{{ favorite.apport|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Frais de cautionnement</th>
                                                    <td>{{ favorite.deposit_fees|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Taux crédit</th>
                                                    <td>{{ favorite.rate|number:'1.0-1'}} %</td>
                                                </tr>
                                                <tr>
                                                    <th>Taux assurance</th>
                                                    <td>{{ favorite.rate_insurance|number:'1.0-1'}} %</td>
                                                </tr>
                                                <tr>
                                                    <th>Durée</th>
                                                    <td>{{ favorite.duration|number:'1.0-1'}} ans</td>
                                                </tr>
                                                <tr>
                                                    <th>Annuité</th>
                                                    <td>{{ favorite.monthly * 12|number:'1.0-1'}} €</td>
                                                </tr>
                                                <tr>
                                                    <th>Mensualité</th>
                                                    <td>{{ favorite.monthly|number:'1.0-1'}} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clear"></div>

                        <div class="kpi kpi-color-10 kpi-small">
                            Pack confort gestion locative : {{ favorite.amount_rent * 0.08 * 12 |number:'1.0-1'}} €/an
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                    Document non contractuel sous réserve d'acceptation et normes des banques en vigueur.
                </span>
                </p>
            </div>
        </div>

        <div id="finance_3" class="page">
            <div class="subpage">

                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière sur {{ favorite.duration }} ans
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="card block block_bilan">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Bilan comptable prévisionnel
                                    <ng-container *ngIf="favorite.selling == true"> avec revente</ng-container>
                                </h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <table mat-table class="bilan_comptable" [dataSource]="result | slice:0:favorite.duration + 1">
                                    <ng-container matColumnDef="amortissement">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Amortissement</span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annee">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element"> {{element.annee}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.base_imposable | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.base_imposable_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash-flow
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.cash_flow | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash flow
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cash_flow_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Charges
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.charges | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cumul_deficit_benefice">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cumul déficit<br/>ou bénéfice
-                                       </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cumul_deficit_benefice | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_plus_value">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>la plus value
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_plus_value | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage fiscal
                                         </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.avantage_fiscal | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage<br/>fiscal
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.avantage_fiscal_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_avec_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés avec revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes_avec_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impots_revenus | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impots_revenus_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements<br/>sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prelev_sociaux | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements<br/>sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prelev_sociaux_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="loyers_percus">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Loyers
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.loyers_percus | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="int_emprunt">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Intérêts<br/>d'emprunt
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.int_emprunt | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="renta_nette_impot">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Rendement<br/>net d'impôts
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.renta_nette_impot * 100 | number:'1.2-2'}}
                                            %
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annuite">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Annuité
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.annuite | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="capital_restant_du">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Capital<br/>restant dû
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.capital_restant_du | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_charge | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_charge_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_charges | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_charges_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_amortissement_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_amortissement_revente | number: '1.0-0'}}
                                            €
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations<br/>sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cotisations_sociales | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations<br/>sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cotisations_sociales_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prix_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Prix de revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prix_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="treso_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Trésorerie<br/>cumulée
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.treso_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="card block block_bilan">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution du Cash-Flow</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row" *ngIf="capitalData.series.length > 0">
                                <div echarts echarts [options]="optionsCF" [merge]="cashflowData"
                                     class="chartCf" (chartInit)="onChartCFInit($event)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="kpi-3 mb-1" *ngIf="result.length > 0">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer mensuel HC</label>
                            <p class="value">{{ favorite.amount_rent | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-2 kpi-label-2">
                            <img class="icon" src="assets/030-cash.png"/>
                            <label>Charges mensuelles<br/>(avec crédit)</label>
                            <p class="value">{{ favorite.charge + favorite.monthly | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ efficiency_brut | number: '1.1-1' }} %</p>
                        </div>
                    </div>
                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                    Document non contractuel sous réserve d'acceptation et normes des banques en vigueur.
                </span>
                </p>
            </div>
        </div>
        <div id="finance_3_25" class="page">
            <div class="subpage">

                <div class="subpageWrap">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière sur 25 ans
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="card block block_bilan">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Bilan comptable prévisionnel
                                    <ng-container *ngIf="favorite.selling == true"> avec revente</ng-container>
                                </h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <table mat-table class="bilan_comptable" [dataSource]="result25 | slice:0:26">
                                    <ng-container matColumnDef="amortissement">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Amortissement</span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annee">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element"> {{element.annee}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.base_imposable | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.base_imposable_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash-flow
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.cash_flow | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash flow
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cash_flow_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Charges
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.charges | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cumul_deficit_benefice">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cumul déficit<br/>ou bénéfice
-                                       </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cumul_deficit_benefice | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_plus_value">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>la plus value
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_plus_value | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage fiscal
                                         </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.avantage_fiscal | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage<br/>fiscal
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.avantage_fiscal_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_avec_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>les sociétés avec revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impot_societes_avec_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impots_revenus | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur<br/>le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.impots_revenus_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements<br/>sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prelev_sociaux | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements<br/>sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prelev_sociaux_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="loyers_percus">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Loyers
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.loyers_percus | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="int_emprunt">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Intérêts<br/>d'emprunt
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.int_emprunt | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="renta_nette_impot">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Rendement<br/>net d'impôts
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.renta_nette_impot * 100 | number:'1.2-2'}}
                                            %
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annuite">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Annuité
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.annuite | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="capital_restant_du">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Capital<br/>restant dû
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.capital_restant_du | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_charge | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_charge_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_charges | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_charges_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.report_amortissement_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_amortissement | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock<br/>amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.stock_amortissement_revente | number: '1.0-0'}}
                                            €
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations<br/>sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cotisations_sociales | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations<br/>sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.cotisations_sociales_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prix_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Prix de revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.prix_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="treso_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Trésorerie<br/>cumulée
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{element.treso_revente | number: '1.0-0'}}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="card block block_bilan">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-blue">Évolution du Cash-Flow</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row" *ngIf="capitalData25.series.length > 0">
                                <div echarts echarts [options]="optionsCF" [merge]="cashflowData25"
                                     class="chartCf" (chartInit)="onChartCFInit($event)"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                    Document non contractuel sous réserve d'acceptation et normes des banques en vigueur.
                </span>
                </p>
            </div>
        </div>

        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>
    </div>
</div>
